
import './about.css';

import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faFileContract,
  faBookOpen,
  faUserLock,
  faCopyright,
  faCreditCard,
  faUndo,
  faUserShield,
  faExclamationTriangle,
  faEdit,
  faEnvelope,
  faBuilding,
  faClock,
} from '@fortawesome/free-solid-svg-icons';

const Termeni = () => {
  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">

        <div className="tittle-ab-top">
          <h4>Termeni si conditii</h4>
        </div>

        {/* INFORMATII GENERALE */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faFileContract}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Informatii generale</h4>

            <p>
              Prezenta sectiune stabileste termenii si conditiile
              de utilizare a platformei educationale ContaLearn,
              disponibila la adresa www.contalearn.ro.
            </p>

            <p>
              Platforma pune la dispozitia utilizatorilor
              materiale educationale, exercitii interactive,
              teste si functionalitati dedicate invatarii contabilitatii.
            </p>

            <p>
              Prin crearea unui cont si utilizarea serviciilor
              care necesita acceptarea acestor termeni,
              utilizatorul confirma ca a luat cunostinta
              de conditiile aplicabile.
            </p>
          </div>
        </section>

        {/* OPERATORUL PLATFORMEI */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Operatorul platformei</h4>

            <p>
              Platforma ContaLearn este administrata de
              <strong> CONTALEARN S.R.L.</strong>,
              societate inregistrata in Romania.
            </p>

            <p>
              <strong>Denumire:</strong> CONTALEARN S.R.L.
            </p>

            <p>
              <strong>CUI:</strong> 55705840
            </p>

            <p>
              <strong>Numar Registrul Comertului:</strong>
              {' '}J2026057859008
            </p>

            <p>
              <strong>Sediu social:</strong>
              {' '}Str. Sarmisegetuza nr. 16-17,
              et. P, ap. SP 2,
              Cluj-Napoca, judetul Cluj, Romania.
            </p>

            <p>
              <strong>Email:</strong>
              {' '}
              <a href="mailto:contact@contalearn.ro">
                contact@contalearn.ro
              </a>
            </p>

            <p>
              Informatii suplimentare sunt disponibile
              in pagina{' '}
              <Link to="/about">Despre noi</Link>.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faBuilding}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* DESCRIEREA SERVICIILOR */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faBookOpen}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Descrierea serviciilor</h4>

            <p>
              ContaLearn ofera cursuri interactive de contabilitate,
              materiale educationale, teste, exercitii practice,
              simulari si instrumente de evaluare a cunostintelor.
            </p>

            <p>
              Anumite resurse sunt disponibile gratuit,
              iar altele necesita achizitionarea unui plan
              de acces premium.
            </p>

            <p>
              Continutul are scop educational si nu reprezinta
              consultanta contabila, fiscala sau juridica
              individualizata.
            </p>
          </div>
        </section>

        {/* CONTUL UTILIZATORULUI */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Crearea si utilizarea contului</h4>

            <p>
              Pentru accesarea anumitor functionalitati,
              utilizatorul trebuie sa isi creeze un cont.
            </p>

            <p>
              Utilizatorul este responsabil pentru pastrarea
              confidentialitatii datelor de autentificare
              si pentru protejarea accesului la contul propriu.
            </p>

            <p>
              Este interzisa utilizarea frauduloasa a platformei,
              accesarea neautorizata a conturilor altor persoane
              sau orice activitate care afecteaza securitatea
              si functionarea serviciilor ContaLearn.
            </p>

            <p>
              In cazul incalcarii regulilor, pot fi aplicate
              masuri proportionale de restrictionare sau
              suspendare a accesului, cu respectarea
              legislatiei aplicabile.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faUserLock}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* DREPTURI DE AUTOR */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faCopyright}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Drepturi de autor si proprietate intelectuala</h4>

            <p>
              Materialele originale disponibile pe ContaLearn,
              inclusiv textele, exercitiile, elementele grafice,
              materialele video si componentele software,
              sunt protejate de legislatia privind
              proprietatea intelectuala.
            </p>

            <p>
              Drepturile apartin CONTALEARN S.R.L.
              sau titularilor care au autorizat utilizarea
              materialelor respective.
            </p>

            <p>
              Este interzisa redistribuirea, comercializarea
              sau reproducerea neautorizata a continutului,
              cu exceptia utilizarilor permise de lege
              sau autorizate de titularii drepturilor.
            </p>
          </div>
        </section>

        {/* PLATI PRIN STRIPE */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Plati si acces premium</h4>

            <p>
              ContaLearn comercializeaza planuri de acces premium
              prin intermediul unor <strong>plati unice</strong>.
            </p>

            <p>
              Achizitionarea unui plan presupune achitarea
              unei singure sume pentru perioada de acces
              indicata in oferta selectata.
            </p>

            <p>
              <strong>
                Plata nu determina reinnoirea automata a accesului
                si nu presupune debitari recurente.
              </strong>
            </p>

            <p>
              Procesarea platilor online se realizeaza
              prin intermediul <strong>Stripe</strong>,
              furnizor specializat in procesarea
              platilor electronice.
            </p>

            <p>
              Inainte de finalizarea achizitiei,
              utilizatorului ii sunt prezentate
              pretul total, moneda, perioada accesului,
              functionalitatile incluse si conditiile
              aplicabile tranzactiei.
            </p>

            <p>
              Preturile si planurile disponibile pot fi
              consultate in sectiunea{' '}
              <Link to="/viewplans">Preturi</Link>.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faCreditCard}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* DURATA ACCESULUI */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faClock}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Durata accesului premium</h4>

            <p>
              Durata accesului premium este cea indicata
              in descrierea planului achizitionat
              si confirmata la momentul cumpararii.
            </p>

            <p>
              Accesul este acordat dupa confirmarea
              platii, in conditiile specifice
              planului achizitionat.
            </p>

            <p>
              La expirarea perioadei achizitionate,
              dreptul de acces la functionalitatile
              premium aferente acelui plan inceteaza,
              daca utilizatorul nu achizitioneaza
              o noua perioada de acces.
            </p>

            <p>
              <strong>
                ContaLearn nu efectueaza automat
                o noua plata la expirarea accesului.
              </strong>
            </p>
          </div>
        </section>

        {/* ANULAREA ACCESULUI */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Anularea accesului premium</h4>

            <p>
              Utilizatorul poate solicita anularea
              accesului premium prin functionalitatile
              disponibile in cont sau prin intermediul
              canalelor de contact ContaLearn.
            </p>

            <p>
              Intrucat planurile sunt achizitionate
              prin plata unica, anularea accesului
              nu are rolul de a opri plati viitoare
              programate automat.
            </p>

            <p>
              <strong>
                Anularea accesului nu presupune automat
                rambursarea sumei achitate.
              </strong>
            </p>

            <p>
              Solicitarile de restituire a banilor
              sunt analizate separat, in conformitate
              cu drepturile legale ale consumatorului
              si cu conditiile aplicabile achizitiei.
            </p>

            <p>
              Pentru asistenta privind anularea,
              poti utiliza{' '}
              <Link to="/ajutor">pagina de contact</Link>.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faUndo}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* RETRAGERE SI RAMBURSARE */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faFileContract}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Dreptul de retragere si rambursare</h4>

            <p>
              Pentru contractele incheiate la distanta,
              consumatorii beneficiaza, in conditiile
              prevazute de OUG nr. 34/2014,
              de un drept de retragere de 14 zile.
            </p>

            <p>
              Pentru serviciile si continutul digital,
              exercitarea dreptului de retragere
              poate fi supusa unor conditii
              si exceptii prevazute de lege.
            </p>

            <p>
              In cazurile in care este necesar
              acordul prealabil expres al consumatorului
              pentru inceperea furnizarii continutului digital
              si confirmarea pierderii dreptului de retragere,
              acestea sunt solicitate separat,
              in conditiile legislatiei aplicabile.
            </p>

            <p>
              Simpla accesare a platformei sau finalizarea
              unui modul nu determina automat pierderea
              dreptului de retragere in afara
              situatiilor prevazute de lege.
            </p>

            <p>
              Pentru a solicita retragerea
              sau o rambursare, utilizatorul poate
              transmite o cerere la{' '}
              <a href="mailto:contact@contalearn.ro">
               contact@contalearn.ro
              </a>.
            </p>

            <p>
              Rambursarile aprobate se efectueaza
              potrivit legislatiei aplicabile,
              utilizand, de regula, aceeasi metoda
              de plata folosita la tranzactia initiala,
              cu respectarea conditiilor legale.
            </p>
          </div>
        </section>

        {/* COMPORTAMENT ACCEPTABIL */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Comportament acceptabil</h4>

            <p>
              Utilizatorii trebuie sa foloseasca
              platforma in mod legal, responsabil
              si respectuos fata de ceilalti utilizatori.
            </p>

            <p>
              Sunt interzise tentativele de frauda,
              distribuirea continutului ilegal,
              accesul neautorizat si activitatile
              care afecteaza functionarea sau
              securitatea platformei.
            </p>

            <p>
              Continutul publicat in forum sau transmis
              prin feedback trebuie sa respecte
              drepturile celorlalte persoane.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faUserShield}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* LIMITAREA RESPONSABILITATII */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Limitarea responsabilitatii</h4>

            <p>
              ContaLearn depune eforturi pentru
              a furniza materiale educationale
              clare, relevante si actualizate.
            </p>

            <p>
              Continutul platformei are caracter educational
              si nu inlocuieste consultanta profesionala
              adaptata unei situatii concrete.
            </p>

            <p>
              ContaLearn nu garanteaza obtinerea
              unor rezultate educationale sau
              profesionale specifice.
            </p>

            <p>
              Acesti termeni nu limiteaza drepturile
              consumatorilor si nici raspunderea
              care nu poate fi exclusa potrivit legii.
            </p>
          </div>
        </section>

        {/* MODIFICAREA TERMENILOR */}
        <section className="section-about-2">
          <div className="part-text-about">
            <h4>Modificarea termenilor si conditiilor</h4>

            <p>
              ContaLearn poate actualiza acesti termeni
              pentru a reflecta modificari ale serviciilor,
              functionalitatilor sau legislatiei aplicabile.
            </p>

            <p>
              Versiunea actualizata va fi publicata
              pe aceasta pagina.
            </p>

            <p>
              Modificarile care afecteaza drepturile
              si obligatiile existente ale utilizatorilor
              vor respecta cerintele legale privind
              informarea si, dupa caz, acordul acestora.
            </p>
          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faEdit}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>
        </section>

        {/* CONTACT */}
        <section className="section-about-2">
          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">
            <h4>Contact</h4>

            <p>
              Pentru intrebari privind platile,
              accesul premium, rambursarile
              sau acesti termeni si conditii,
              ne poti contacta la:
            </p>

            <p>
              <strong>Email:</strong>{' '}
              <a href="mailto:contact@contalearn.ro">
                contact@contalearn.ro
              </a>
            </p>

            <p>
              De asemenea, poti utiliza{' '}
              <Link to="/ajutor">
                pagina noastra de contact
              </Link>.
            </p>
          </div>
        </section>

        <div className="line-about"></div>

      </div>
    </div>
  );
};

export default Termeni;
